import { $Locale } from '@lemon8/web-app-shared/atom';
import { atom, useAtomValue } from 'jotai';
import { $RootTraffic } from 'shared/atoms';
import { useMemo } from 'react';

const $SharingHrefBuilder = atom((get) => {
  const { sharePlatform, enterHref, sharerToken, isSharingTest } = get($RootTraffic);
  const { region } = get($Locale);

  return (path: string): string => {
    try {
      const url = new URL(path, enterHref);

      if (isSharingTest) {
        url.searchParams.set('sharing_test', '1');
      }

      url.searchParams.set('_r', '1');
      url.searchParams.set('_t', sharerToken);
      url.searchParams.set('region', region);
      url.searchParams.set('share_platform', sharePlatform);

      return `${url.pathname}${url.search}`;
    } catch (e) {
      console.error(e);
      // TODO emit error
      return '';
    }
  };
});

export const useSharingHrefBuilder = () => useAtomValue($SharingHrefBuilder);

export const useSharingUrl = (pathAndSearch: string) => {
  const buildSharingUrl = useSharingHrefBuilder();

  return useMemo(() => {
    return buildSharingUrl(pathAndSearch);
  }, [buildSharingUrl, pathAndSearch]);
};
